<template lang="html">
  <v-container>
    <v-layout justify-center>
      <v-flex lg6 md8 sm8 xs12>
        <v-card>
          <v-card-title>TeamSpeak Server bearbeiten</v-card-title>
          <v-card-text>
            <v-text-field
              label="Server Name"
              v-model="serverInfo.virtualserver_name"
              :disabled="$store.state.query.loading"
            ></v-text-field>
            <v-text-field
              label="Passwort"
              v-model="serverInfo.virtualserver_password"
              :disabled="$store.state.query.loading"
              type="password"
            ></v-text-field>
            <v-layout justify-space-between>
              <v-flex xs5>
                <v-text-field
                  label="Maximale Benutzer"
                  v-model="serverInfo.virtualserver_maxclients"
                  type="number"
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs5>
                <v-text-field
                  label="Reservierte Slots"
                  v-model="serverInfo.virtualserver_reserved_slots"
                  :disabled="$store.state.query.loading"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-textarea
              label="Willkommensnachricht"
              v-model="serverInfo.virtualserver_welcomemessage"
              :disabled="$store.state.query.loading"
            ></v-textarea>


            <v-expansion-panels accordion flat>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Host
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-subtitle>Hostnachricht</v-card-subtitle>
                    <v-card-text>
                      <v-text-field
                        label="Nachricht"
                        v-model="serverInfo.virtualserver_hostmessage"
                        :disabled="$store.state.query.loading"
                      ></v-text-field>
                      <v-select
                        label="Modus"
                        v-model="serverInfo.virtualserver_hostmessage_mode"
                        :items="messageModes"
                      ></v-select>
                    </v-card-text>
                  </v-card>
                  <v-card class="mt-2 ">
                    <v-card-subtitle>Hostbanner</v-card-subtitle>
                    <v-card-text>
                      <v-text-field
                        label="Banner Gfx URL"
                        v-model="serverInfo.virtualserver_hostbanner_gfx_url"
                        :disabled="$store.state.query.loading"
                      ></v-text-field>
                      <v-text-field
                        label="URL"
                        v-model="serverInfo.virtualserver_hostbanner_url"
                        :disabled="$store.state.query.loading"
                      ></v-text-field>
                      <v-layout justify-space-between>
                        <v-flex xs4>
                          <v-text-field
                            label="Gfx Interval"
                            v-model="serverInfo.virtualserver_hostbanner_gfx_interval"
                            type="number"
                            :disabled="$store.state.query.loading"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            label="Größe"
                            :items="bannerModes"
                            v-model="serverInfo.virtualserver_hostbanner_mode"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <v-card class="my-2 ">
                    <v-card-subtitle>Hostbutton</v-card-subtitle>
                    <v-card-text>
                      <v-text-field
                        label="Tooltip"
                        v-model="serverInfo.virtualserver_hostbutton_tooltip"
                        :disabled="$store.state.query.loading"
                      ></v-text-field>
                      <v-text-field
                        label="URL"
                        v-model="serverInfo.virtualserver_hostbutton_url"
                        :disabled="$store.state.query.loading"
                      ></v-text-field>
                      <v-text-field
                        label="Icon URL"
                        v-model="serverInfo.virtualserver_hostbutton_gfx_url"
                        :disabled="$store.state.query.loading"
                      ></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Übertragungen
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card class="">
                    <v-card-subtitle>Upload</v-card-subtitle>
                    <v-card-text>
                      <v-text-field
                        label="Bandbreitenlimit"
                        v-model="serverInfo.virtualserver_max_upload_total_bandwidth"
                        :disabled="$store.state.query.loading"
                        type="number"
                      >
                        <template #append>
                          <div>Byte/s</div>
                        </template>
                      </v-text-field>
                      <v-text-field
                        label="Upload Quota"
                        v-model="serverInfo.virtualserver_upload_quota"
                        :disabled="$store.state.query.loading"
                        type="number"
                      >
                        <template #append>
                          <div>MiB</div>
                        </template>
                      </v-text-field>
                    </v-card-text>
                  </v-card>
                  <v-card class="my-2 ">
                    <v-card-subtitle>Download</v-card-subtitle>
                    <v-card-text>
                      <v-text-field
                        label="Bandbreitenlimit"
                        v-model="serverInfo.virtualserver_max_download_total_bandwidth"
                        :disabled="$store.state.query.loading"
                        type="number"
                      >
                        <template #append>
                          <div>Byte/s</div>
                        </template>
                      </v-text-field>
                      <v-text-field
                        label="Download Quota"
                        v-model="serverInfo.virtualserver_download_quota"
                        :disabled="$store.state.query.loading"
                        type="number"
                      >
                        <template #append>
                          <div>MiB</div>
                        </template>
                      </v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Anti-Flood
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card class="mb-2 ">
                    <v-card-text>
                      <v-text-field
                        label="Reduziere Punkte pro Tick"
                        v-model="serverInfo.virtualserver_antiflood_points_tick_reduce"
                        :disabled="$store.state.query.loading"
                        type="number"
                      ></v-text-field>
                      <v-text-field
                        label="Punkte, um Befehle zu blockieren"
                        v-model="serverInfo.virtualserver_antiflood_points_needed_command_block"
                        :disabled="$store.state.query.loading"
                        type="number"
                      ></v-text-field>
                      <v-text-field
                        label="Punkte, um IP zu sperren"
                        v-model="serverInfo.virtualserver_antiflood_points_needed_ip_block"
                        :disabled="$store.state.query.loading"
                        type="number"
                      ></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Sicherheit
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card class="mb-2 ">
                    <v-card-text>
                      <v-text-field
                        label="Benötigte Sicherheitsstufe"
                        v-model="serverInfo.virtualserver_needed_identity_security_level"
                        :disabled="$store.state.query.loading"
                        type="number"
                      ></v-text-field>
                      <v-select
                        label="Channel voice Verschlüsselung"
                        v-model="serverInfo.virtualserver_codec_encryption_mode"
                        :items="encryptionModes"
                      ></v-select>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Verschiedenes
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card class="">
                    <v-card-subtitle>Standard Gruppen</v-card-subtitle>
                    <v-card-text>
                      <v-autocomplete
                        :items="serverGroups"
                        item-text="name"
                        item-value="sgid"
                        v-model="serverInfo.virtualserver_default_server_group"
                        label="Servergruppe"
                        :disabled="$store.state.query.loading"
                      >
                        <template #selection="{item}">
                          <div>{{ item.name }} ({{ item.sgid }})</div>
                        </template>
                        <template #item="{item}">
                          <div>{{ item.name }} ({{ item.sgid }})</div>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete
                        :items="channelGroups"
                        item-text="name"
                        item-value="cgid"
                        v-model="serverInfo.virtualserver_default_channel_group"
                        label="Channelgruppe"
                        :disabled="$store.state.query.loading"
                      >
                        <template #selection="{item}">
                          <div>{{ item.name }} ({{ item.cgid }})</div>
                        </template>
                        <template #item="{item}">
                          <div>{{ item.name }} ({{ item.cgid }})</div>
                        </template>
                      </v-autocomplete>
                      <v-autocomplete
                        :items="channelGroups"
                        item-text="name"
                        item-value="cgid"
                        v-model="serverInfo.virtualserver_default_channel_admin_group"
                        label="Channel Admingruppe"
                        :disabled="$store.state.query.loading"
                      >
                        <template #selection="{item}">
                          <div>{{ item.name }} ({{ item.cgid }})</div>
                        </template>
                        <template #item="{item}">
                          <div>{{ item.name }} ({{ item.cgid }})</div>
                        </template>
                      </v-autocomplete>
                    </v-card-text>
                  </v-card>
                  <v-card class="mt-2 ">
                    <v-card-subtitle>Beschwerde</v-card-subtitle>
                    <v-card-text>
                      <v-layout justify-space-between wrap>
                        <v-flex xs5 md3>
                          <v-text-field
                            label="Autoban Anzahl"
                            :disabled="$store.state.query.loading"
                            v-model="serverInfo.virtualserver_complain_autoban_count"
                            type="number"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs5 md3>
                          <v-text-field
                            label="Autoban Dauer"
                            :disabled="$store.state.query.loading"
                            v-model="serverInfo.virtualserver_complain_autoban_time"
                            type="number"
                          >
                            <template #append>
                              <div>Sekunden</div>
                            </template>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs5 md3>
                          <v-text-field
                            label="Entfernen nach"
                            :disabled="$store.state.query.loading"
                            v-model="serverInfo.virtualserver_complain_remove_time"
                            type="number"
                          >
                            <template #append>
                              <div>Sekunden</div>
                            </template>
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <v-card class="my-2 ">
                    <v-card-text>
                      <v-text-field
                        label="Min clients im Channel für Stille"
                        :disabled="$store.state.query.loading"
                        v-model="serverInfo.virtualserver_min_clients_in_channel_before_forced_silence"
                        type="number"
                      ></v-text-field>
                      <v-text-field
                        label="Abschwächung des Gesprächleiters"
                        :disabled="$store.state.query.loading"
                        v-model="serverInfo.virtualserver_priority_speaker_dimm_modificator"
                        type="number"
                      ></v-text-field>
                      <v-text-field
                        label="Verzögerung des Löschen temporärer Channel"
                        :disabled="$store.state.query.loading"
                        v-model="serverInfo.virtualserver_channel_temp_delete_delay_default"
                        type="number"
                      ></v-text-field>
                      <v-text-field
                        label="Phonetischer Name"
                        :disabled="$store.state.query.loading"
                        v-model="serverInfo.virtualserver_name_phonetic"
                      ></v-text-field>
                      <v-checkbox
                        label="Report an Server List"
                        v-model="weblistEnabled"
                      ></v-checkbox>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Protokoll
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card class="mb-2 ">
                    <v-card-subtitle>Protokollierung aktivieren für</v-card-subtitle>
                    <v-card-text>
                      <v-checkbox label="Benuzter" v-model="logClient"
                      ></v-checkbox>
                      <v-checkbox label="Channel" v-model="logChannel"
                      ></v-checkbox>
                      <v-checkbox label="Server" v-model="logServer"
                      ></v-checkbox>
                      <v-checkbox label="ServerQuery" v-model="logQuery"
                      ></v-checkbox>
                      <v-checkbox label="Rechte" v-model="logPermissions"
                      ></v-checkbox>
                      <v-checkbox label="Dateitransfer" v-model="logFileTransfer"
                      ></v-checkbox>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="this.$store.state.query.loading"
              color="primary"
              @click="saveChanges"
            >OK
            </v-btn>
            <v-btn text @click="$router.go(-1)" color="primary">Abbrechen</v-btn>
            <v-btn
              text
              :disabled="this.$store.state.query.loading"
              color="primary"
              @click="applyChanges"
            >Übernehmen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      serverInfo: {},
      serverInfoCopy: {},
      messageModes: [
        {text: "Keine Nachricht (NONE)", value: 0},
        {text: "Nachricht im Log zeigen (LOG)", value: 1},
        {text: "Nachricht als Fenster zeigen (MODAL)", value: 2},
        {text: "Nachticht als Fenster zeigen und Verbindung trennen (MODALQUIT)", value: 3},
      ],
      bannerModes: [
        {text: "Nicht anpassen", value: 0},
        {text: "Anpassen, Seitenverhältnis ignorieren", value: 1},
        {text: "Anpassen, Seitenverhältnis beachten", value: 2}
      ],
      encryptionModes: [
        {text: "Channel individuell einstellen", value: 0},
        {text: "Global Aus", value: 1},
        {text: "Global An", value: 2},
      ],
      serverGroups: [],
      channelGroups: []
    }
  },
  computed: {
    weblistEnabled: {
      get() {
        return this.serverInfo.virtualserver_weblist_enabled ? true : false
      },
      set(bool) {
        this.serverInfo.virtualserver_weblist_enabled = bool ? 1 : 0
      }
    },
    logClient: {
      get() {
        return this.serverInfo.virtualserver_log_client ? true : false
      },
      set(bool) {
        this.serverInfo.virtualserver_log_client = bool ? 1 : 0
      }
    },
    logQuery: {
      get() {
        return this.serverInfo.virtualserver_log_query ? true : false
      },
      set(bool) {
        this.serverInfo.virtualserver_log_query = bool ? 1 : 0
      }
    },
    logChannel: {
      get() {
        return this.serverInfo.virtualserver_log_channel ? true : false
      },
      set(bool) {
        this.serverInfo.virtualserver_log_channel = bool ? 1 : 0
      }
    },
    logPermissions: {
      get() {
        return this.serverInfo.virtualserver_log_permissions ? true : false
      },
      set(bool) {
        this.serverInfo.virtualserver_log_permissions = bool ? 1 : 0
      }
    },
    logServer: {
      get() {
        return this.serverInfo.virtualserver_log_server ? true : false
      },
      set(bool) {
        this.serverInfo.virtualserver_log_server = bool ? 1 : 0
      }
    },
    logFileTransfer: {
      get() {
        return this.serverInfo.virtualserver_log_filetransfer ? true : false
      },
      set(bool) {
        this.serverInfo.virtualserver_log_filetransfer = bool ? 1 : 0
      }
    }
  },
  methods: {
    getServerInfo() {
      return this.$TeamSpeak.execute("serverinfo").then(arr => arr[0])
    },
    getServerGroupList() {
      return this.$TeamSpeak.execute("servergrouplist")
        .then(groups => groups.filter(group => group.type === 1))
    },
    getChannelGroupList() {
      return this.$TeamSpeak.execute("channelgrouplist")
        .then(groups => groups.filter(group => group.type === 1))
    },
    getChanges() {
      let changes = {}

      for (let prop in this.serverInfo) {
        if (this.serverInfo[prop] !== this.serverInfoCopy[prop]) {
          changes[prop] = this.serverInfo[prop]
        }
      }

      return changes
    },
    serverEdit() {
      return this.$TeamSpeak.execute("serveredit", this.getChanges())
    },
    async saveChanges() {
      try {
        await this.serverEdit()

        this.$router.go(-1)
      } catch(err) {
        this.$toast.error(err.message)
      }
    },
    async applyChanges() {
      try {
        await this.serverEdit()
      } catch(err) {
        this.$toast.error(err.message)
      }

      this.init()
    },
    async init() {
      try {
        this.serverInfo = await this.getServerInfo()
        this.serverInfoCopy = {...this.serverInfo}
        this.serverGroups = await this.getServerGroupList()
        this.channelGroups = await this.getChannelGroupList()
      } catch(err) {
        this.$toast.error(err.message)
      }
    }
  },
  created() {
    this.init()
  }
}
</script>
